
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.042 1.755A1.417 1.417 0 0010.533.338H1.509A1.417 1.417 0 000 1.755V7.818a1.849 1.849 0 001.82 1.863h2.373v.347c-.017.27-.105.532-.255.758a2.564 2.564 0 00.432 3.223c.924.875 2.37.875 3.294 0 .528-.48.827-1.163.822-1.877a2.543 2.543 0 00-.34-1.346 1.495 1.495 0 01-.27-.8l-.063-.32 2.437.064a1.849 1.849 0 001.82-1.862v-.8l-.028-5.313zm-10.93 0c0-.107 0-.305.397-.305h9.024c.397 0 .397.198.397.305v4.2H1.112v-4.2zm9.159 6.927a.78.78 0 00.708-.8v-.815H1.063v.751a.78.78 0 00.765.8H4.25a1.02 1.02 0 01.999 1.035V10a2.585 2.585 0 01-.425 1.36 1.502 1.502 0 00-.22.793c0 .42.181.82.496 1.098.534.466 1.33.466 1.863 0 .306-.282.479-.681.475-1.098.01-.28-.057-.556-.192-.8A2.543 2.543 0 016.821 10v-.347a1.02 1.02 0 011.013-1.035l2.437.064z","fill":"#fff"}}),_c('path',{attrs:{"d":"M2.479 1.833a.531.531 0 00-.532.53v2.459a.531.531 0 101.063 0V2.364a.538.538 0 00-.531-.531zM4.604 1.833a.538.538 0 00-.532.53v1.24a.531.531 0 101.063 0v-1.24a.538.538 0 00-.531-.53z","fill":"#fff"}})])
          )
        }
      }
    